export default {
  UploadMsgWrongFormatCSV: 'Wrong format of file selected. Only csv/excel formatted files are allowed.',
  UploadMsgWrongFormatDOC: 'Wrong format of file selected. Only PDF/JPEG/JPG/PNG/DOC/DOCX formatted files are allowed.',
  UploadMsgNoFile: 'No file selected.',
  UploadMsgInProgress: 'File upload is still in progress.'
}
